"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeUpJs = makeUpJs;
var _build = _interopRequireDefault(require("./build.js"));
var _main = _interopRequireDefault(require("./main.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var confGlobal;
/**
 * 组装js 【入口函数】
 * @param {String} type 生成类型，文件或弹窗等
 */
var ruleProp = {};
var thisForm = "";
function makeUpJs(componentList, dataSource) {
  confGlobal = componentList;
  var dataList = ["\n\t\tsource:window.LOWCODE.source,\n\t\timageViewVisible:false,\n\t\timageViewDataList:[],\n\t"];
  var propsList = [];
  var methodList = [];
  var created = [];
  var mounted = ["window.LOWCODE.$refs = this.$refs;"];
  var watchList = [];
  //初始化加载API方法
  _build["default"].mixinInitMethod(dataSource, dataList, methodList, mounted);
  //初始化加载JSOject方法
  _build["default"].mixinInitMounted(dataSource, dataList, methodList, mounted);
  componentList.forEach(function (el) {
    buildAttributes(el, dataList, methodList, propsList, created, mounted, watchList);
  });
  Object.keys(ruleProp).forEach(function (item) {
    dataList.push("".concat(item, ":").concat(JSON.stringify(ruleProp[item]), ","));
  });
  var script = buildexport(dataList.join('\n'), propsList.join('\n'), methodList.join('\n'), created.join('\n'), mounted.join('\n'), watchList.join('\n'));
  confGlobal = null;
  return script;
}

// 构建组件属性
function buildAttributes(scheme, dataList, methodList, propsList, created, mounted, watchList) {
  var config = scheme.__config__;
  var slot = scheme.__slot__;
  buildData(scheme, dataList, methodList);
  // buildProps(scheme, propsList);
  buildMethod(scheme, methodList, mounted);

  // 构建子级组件属性
  if (config.children) {
    config.children.forEach(function (item) {
      buildAttributes(item, dataList, methodList, propsList, created, mounted, watchList);
    });
  }
  // 构建tabs/collapse组件属性
  if (config && (config.tagType == "tabs" || config.tagType == "collapse")) {
    if (slot.list) {
      slot.list.map(function (child) {
        child.list.forEach(function (item) {
          buildAttributes(item, dataList, methodList, propsList, created, mounted, watchList);
        });
      });
    }
  }
  // 构建dialog/table组件属性
  if (config && (config.tagType == "dialog" || config.tagType == "table")) {
    if (slot.expand.list && slot.expand.list.length > 0) {
      slot.expand.list.map(function (item) {
        buildAttributes(item, dataList, methodList, propsList, created, mounted, watchList);
      });
    }
  }
}
// 构建data
function buildData(scheme, dataList) {
  if (scheme.__config__ && scheme.__config__.regList && scheme.__config__.regList.length > 0) {
    ruleProp[thisForm + 'Rule'][scheme.__config__.target] = _build["default"].transRules(scheme.__config__.regList);
  }
  var source = _main["default"].getComponentVmodel(scheme, confGlobal);
  var formComponentList = ['el-input', 'el-select', 'el-cascader', 'el-radio-group', 'el-checkbox-group', 'el-input-number', 'el-switch', 'el-slider', 'el-time-picker', 'el-date-picker', 'el-color-picker'];
  if (!source[0] && formComponentList.includes(scheme.__config__.tag)) {
    if (scheme.__config__.tag == 'el-checkbox-group') {
      ruleProp[thisForm][scheme.__config__.target] = scheme.__config__.defaultValue || [];
    } else {
      ruleProp[thisForm][scheme.__config__.target] = scheme.__config__.defaultValue || '';
    }
  }
  var vmodel = null;
  if (scheme.__config__.tag == 'yl-lc-title') {
    vmodel = "".concat(scheme.__config__.target, "Title:").concat(_build["default"].createTitle(scheme), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-search') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.searchParmas), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-card') {
    if (!scheme.title.dataSource) {
      scheme.title.dataSource = {
        isHtml: false,
        body: ''
      };
    }
    vmodel = "".concat(scheme.__config__.target, "Title: ").concat(JSON.stringify(scheme.title), ",");
    // let children = scheme.__config__.children;
    // if(children	&& children.length>0 && children[0].__config__.children && children[0].__config__.children.length>0){
    // 	children[0].__config__.children.map(item=>{
    // 		buildData(item,dataList);
    // 	})
    // }
  }

  if (scheme.__config__.tag == 'yl-lc-table') {
    vmodel = "".concat(scheme.__config__.target, "Data: ").concat(JSON.stringify(scheme.data), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-dialog') {
    vmodel = "".concat(scheme.__config__.target, "Visible: false,");
    scheme.__config__.buttonList.forEach(function (item, index) {
      if (!item.isDisabled) {
        item.isDisabled = {
          isAction: true,
          status: false,
          body: ""
        };
      }
      vmodel += "".concat(scheme.__config__.target).concat(index, "Disabled: ").concat(item.isDisabled.isAction ? item.isDisabled.status : _main["default"].replaceObjectChars(item.isDisabled.body), ",");
    });
    // if(scheme.__slot__.expand.list.length>0){
    // 	scheme.__slot__.expand.list.forEach(child=>{
    // 		buildData(child,dataList);
    // 	})
    // }
  }

  if (scheme.__config__.tag == 'el-tabs') {
    vmodel = "".concat(scheme.__config__.target, ":'").concat(scheme.__config__.defaultValue, "',");
    var val = "";
    if (scheme.__slot__.list && scheme.__slot__.list.length > 0) {
      scheme.__slot__.list.map(function (item, index) {
        var temp = "";
        if (item.labelVar.indexOf("{") == -1) {
          temp = "'".concat(item.labelVar, "'");
        } else {
          temp = "".concat(_main["default"].replaceVal(item.labelVar));
        }
        val += "tab".concat(index, ":").concat(temp, ",");
      });
    }
    vmodel += "".concat(scheme.__config__.target, "Label:{").concat(val, "},");
  }
  if (scheme.__config__.tag == 'el-collapse') {
    vmodel = "\n\t\t\t".concat(scheme.__config__.target, ":'").concat(scheme.__config__.defaultValue, "',\n\t\t");
    // if(scheme.__slot__.list && scheme.__slot__.list.length>0){
    // 	scheme.__slot__.list.map((item,index)=>{
    // 		vmodel += build.createCollapseStatus(scheme,item,index);
    // 		if(item.list.length>0){
    // 			item.list.forEach(child=>{
    // 				buildData(child,dataList);
    // 			})
    // 		}
    // 	})
    // }
  }

  if (scheme.__config__.tag == 'yl-lc-form') {
    vmodel = "".concat(scheme.__config__.target, "Params: ").concat(JSON.stringify(scheme.searchParmas), ",");
    if (scheme.__config__.children && scheme.__config__.children.length > 0) {
      scheme.__config__.children.map(function (item) {
        buildData(item, dataList);
      });
    }
    vmodel += "".concat(scheme.__config__.target, "Button: ").concat(JSON.stringify(scheme.formButton), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-button') {
    vmodel = "".concat(scheme.__config__.target, "Data: ").concat(JSON.stringify(scheme.dataSource), ",");
    if (scheme.__on__ && scheme.__on__[0] && scheme.__on__[0].method.includes('api')) {
      vmodel += "".concat(scheme.__config__.target, "Methods: ").concat(JSON.stringify(scheme.__on__[0]), ",");
    }
  }
  if (scheme.__config__.tag == 'yl-lc-formReadOnly') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.params), ",");
  }
  if (scheme.__config__.tag == 'el-form') {
    // vmodel = `${scheme.__config__.target}: ${JSON.stringify({})},`
    //vmodel += `${scheme.__config__.target}Rule: ${JSON.stringify({})},`
    var formName = scheme.__config__.target;
    var ruleName = scheme.__config__.target + 'Rule';
    if (!ruleProp[ruleName]) {
      ruleProp[ruleName] = {};
      thisForm = scheme.__config__.target;
    }
    if (!ruleProp[formName]) {
      ruleProp[formName] = {};
      thisForm = scheme.__config__.target;
    }
    if (scheme.__config__.children && scheme.__config__.children.length > 0) {
      scheme.__config__.children.map(function (item) {
        buildData(item, dataList);
      });
    }
  }
  if (scheme.__config__.tag == 'el-select') {}
  if (scheme.__config__.tag == 'el-cascader') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.options), ",");
  }
  if (scheme.__config__.tag == 'el-radio-group') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.__slot__.options), ",");
  }
  if (scheme.__config__.tag == 'el-checkbox-group') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.__slot__.options), ",");
  }
  if (scheme.__config__.tag == 'el-dropdown') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.__slot__['menu']), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-data-census') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.__config__.dataSource), ",");
  }
  if (scheme.__config__.tag == 'el-calendar') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.value), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-upload') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.data), ",");
    vmodel += "".concat(scheme.__config__.target, "File: ").concat(JSON.stringify(scheme.uploadFile), ",");
    vmodel += _build["default"].createStatus(scheme);
  }
  var componentList = ['el-input', 'el-input-number', 'el-switch', 'el-slider', 'el-time-picker', 'el-date-picker'];
  if (componentList.includes(scheme.__config__.tag)) {}
  if (scheme.__config__.tag == 'el-color-picker') {
    vmodel = _build["default"].createStatus(scheme);
  }
  if (scheme.__config__.tag == 'yl-lc-echarts-line') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.chartData), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-echarts-pie') {
    vmodel = "".concat(scheme.__config__.target, ": ").concat(JSON.stringify(scheme.chartData), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-page') {
    vmodel = "".concat(scheme.__config__.target, "Remark:").concat(JSON.stringify(scheme.remarks), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-tree') {
    vmodel = "".concat(scheme.__config__.target, "Data: ").concat(JSON.stringify(scheme.treeData), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-icon') {
    vmodel = "".concat(scheme.__config__.target, "Data: ").concat(JSON.stringify(scheme.iconClass), ",");
    vmodel += "".concat(scheme.__config__.target, "Style: ").concat(JSON.stringify(scheme.__config__.style), ",");
  }
  if (scheme.__config__.tag == 'yl-lc-text') {
    vmodel = "".concat(scheme.__config__.target, "Data: ").concat(JSON.stringify(scheme.dataSource), ",");
  }
  dataList.push(vmodel);
}

// 序列化函数
function replacer(key, value) {
  if (typeof value === 'function') {
    return value.toString();
  }
  return value;
}

// 构建method
function buildMethod(scheme, methodList, mounted) {
  if (scheme.__on__ !== undefined && scheme.__on__.length > 0) {
    _build["default"].createFunction(scheme.__on__, scheme, methodList);
  }
  if (scheme.__config__.tag == 'yl-lc-table') {
    _build["default"].createUpdateTableData(scheme, methodList, mounted);
  }
  if (scheme.__config__.tag == 'yl-lc-dialog') {
    scheme.__config__.buttonList.forEach(function (item) {
      if (item.__on__ && item.__on__.length > 0) {
        _build["default"].createFunction(item.__on__, scheme, methodList);
      }
    });
  }
  if (scheme.__config__.tag == 'yl-lc-echarts-line') {
    _build["default"].createEcharsLine(scheme, methodList, mounted);
  }
  if (scheme.__config__.tag == 'yl-lc-echarts-pie') {
    _build["default"].createEcharsPie(scheme, methodList, mounted);
  }
  if (scheme.__config__.tag == 'yl-lc-card') {
    if (scheme.title.buttonList && scheme.title.buttonList.length > 0) {
      scheme.title.buttonList.forEach(function (item) {
        _build["default"].createFunction(item.eventList, scheme, methodList);
      });
    }
  }
}
// js整体拼接
function buildexport(data, props, methods, created, mounted) {
  var str = "{\n\t\tcomponents: {},\n\t\tprops: [".concat(props, "],\n\t\tdata () {\n\t\t\treturn {\n                ").concat(data, "\n\t\t\t}\n\t\t},\n\t\tcomputed: {},\n\t\twatch:{},\n\t\tcreated () {\n\t\t\t").concat(created, "\n\t\t},\n\t\tmounted () {\n\t\t\t").concat(mounted, "\n\t\t},\n\t\tmethods: {\n\t\t\tasyncData(data){\n\t\t\t\treturn data || ''\n\t\t\t},\n\t\t\t").concat(methods, "\n\t\t}\n\t}");
  return str;
}